var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-select",
        {
          staticStyle: { width: "200px" },
          attrs: { placeholder: "请选择日志类型" },
          model: {
            value: _vm.queryParam.type,
            callback: function ($$v) {
              _vm.$set(_vm.queryParam, "type", $$v)
            },
            expression: "queryParam.type",
          },
        },
        [
          _c("el-option", { attrs: { label: "操作日志", value: "1" } }),
          _c("el-option", { attrs: { label: "系统日志", value: "2" } }),
        ],
        1
      ),
      _vm._v("   "),
      _c(
        "el-select",
        {
          staticStyle: { width: "200px" },
          attrs: { placeholder: "请选择操作类型" },
          model: {
            value: _vm.queryParam.oper,
            callback: function ($$v) {
              _vm.$set(_vm.queryParam, "oper", $$v)
            },
            expression: "queryParam.oper",
          },
        },
        [
          _c("el-option", { attrs: { label: "状态变更", value: "1" } }),
          _c("el-option", { attrs: { label: "用户备注修改", value: "2" } }),
          _c("el-option", { attrs: { label: "内部备注修改", value: "3" } }),
          _c("el-option", { attrs: { label: "订单修改", value: "4" } }),
          _c("el-option", { attrs: { label: "订单配送", value: "5" } }),
          _c("el-option", { attrs: { label: "订单退款", value: "6" } }),
        ],
        1
      ),
      _vm._v("   "),
      _c("el-input", {
        staticStyle: { width: "200px" },
        attrs: { placeholder: "操作人", clearable: "" },
        model: {
          value: _vm.queryParam.operName,
          callback: function ($$v) {
            _vm.$set(_vm.queryParam, "operName", $$v)
          },
          expression: "queryParam.operName",
        },
      }),
      _vm._v("   "),
      _c(
        "el-button",
        {
          attrs: { type: "primary", plain: "" },
          on: { click: _vm.handleQueryList },
        },
        [_vm._v("查询")]
      ),
      _vm._v("   "),
      _c("el-button", { on: { click: _vm.handleReset } }, [_vm._v("重置")]),
      _c(
        "el-table",
        { attrs: { "row-key": "sid", data: _vm.tableData } },
        [
          _c("el-table-column", {
            attrs: {
              type: "selection",
              align: "center",
              "reserve-selection": true,
              width: "55",
            },
          }),
          _c("el-table-column", {
            key: "bplatType",
            attrs: { prop: "bplatType", label: "订单渠道" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.bplatType === 1
                      ? _c("span", [_vm._v("美团")])
                      : scope.row.bplatType === 2
                      ? _c("span", [_vm._v("饿了么")])
                      : scope.row.bplatType === 3
                      ? _c("span", [_vm._v("京东到家")])
                      : scope.row.bplatType === 4
                      ? _c("span", [_vm._v("小程序订单")])
                      : scope.row.bplatType === 6
                      ? _c("span", [_vm._v("TOPS订单")])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            key: "corderNo",
            attrs: { prop: "corderNo", label: "订单号", width: "160" },
          }),
          _c("el-table-column", {
            key: "btype",
            attrs: { prop: "btype", label: "日志类型" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.btype === 1
                      ? _c("span", [_vm._v("操作日志")])
                      : scope.row.btype === 2
                      ? _c("span", [_vm._v("系统日志")])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            key: "boper",
            attrs: { prop: "boper", label: "日志类型" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.boper === 1
                      ? _c("span", [_vm._v("状态变更")])
                      : scope.row.boper === 2
                      ? _c("span", [_vm._v("用户备注修改")])
                      : scope.row.boper === 3
                      ? _c("span", [_vm._v("内部备注修改")])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            key: "soper",
            attrs: { prop: "soper", label: "操作人", width: "160" },
          }),
          _c("el-table-column", {
            key: "soperTime",
            attrs: { prop: "soperTime", label: "操作时间", width: "160" },
          }),
          _c("el-table-column", {
            key: "sOperOld",
            attrs: {
              prop: "soperOld",
              label: "原值",
              width: "160",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            key: "soperNew",
            attrs: {
              prop: "soperNew",
              label: "新值",
              width: "160",
              "show-overflow-tooltip": "",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }